/*
 * Marionette ItemView: StatusItemView
 * -------------------------
 * Displays a status event
 */
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import incident_template from '@/../templates/status-item-incident.hbs';
import maintenance_template from '@/../templates/status-item-maintenance.hbs';
import component_template from '@/../templates/status-item-component.hbs';


    var StatusItemView = Marionette.View.extend({
        modelEvents: {
            'change': 'render'
        },
        getTemplate: function() {
            var template = '';

            switch (this.model.collection.type) {
                case 'component':
                    template = component_template;
                    break;
                case 'scheduled_maintenance':
                    template = maintenance_template;
                    break;
                case 'incident':
                    template = incident_template;
                    break;
            }

            return Handlebars.compile(template);
        },
        tagName: 'li'
    });
    export default StatusItemView;

